module.exports = __webpack_public_path__ + "static/media/offer-gnocsis.eb896db0.png";